import axios from '../services/request'

/* 获取年级 */
export const getPlanGrade = (data = {}) => axios.get('api/exam/getPlanGrade',data);

/* 获取老师 */
export const getTeach = (data = {}) => axios.get('api/exam/getTeach',data);

/* 获取老师班级 */
export const getTeachPlan = (data = {}) => axios.get('api/exam/getTeachPlan',data);

/* 创建考试消息 */
export const createMessage = (data = {}) => axios.post('api/exam/createMessage',data);

/* 获取材料 */
export const questions = (data = {}) => axios.post('api/exam/questions',data);

/* 获取分层 */
export const stratify = (data = {}) => axios.post('api/exam/stratify',data);

/* 生成试卷 */
export const create = (data = {}) => axios.post('api/exam/create',data);

/* 非管理员获取班级 */
export const getnotAdminPlan = (data = {}) => axios.get('api/exam/getnotAdminPlan',data);

/* 对比导入数据 */
export const diffExcel = (data = {}) => axios.post('api/exam/diffExcel',data);

/* 获取预览试卷文章 */
export const getarticl = (data = {}) => axios.post('api/exam/getarticl',data);

export default{
    getPlanGrade,
    getTeach,
    getTeachPlan,
    createMessage,
    questions,
    stratify,
    create,
    getnotAdminPlan,
    diffExcel,
    getarticl
}